import { useContext, useState, useMemo } from 'react';
import { Button, Grid } from '@material-ui/core';
import ContentHeader from 'components/ContentHeader';
import ContentWrapper from 'components/ContentWrapper';
import BrowseData from 'components/BrowseData';
import BrowseProvider from 'providers/browse';
import { Formik } from 'formik';
import Input from '../../Quotes/List/Input';
import BrowseContext from 'contexts/browseContext';
import NumberFormat from 'react-number-format';
import { useDispatch } from 'store';
import { addFeedback } from 'actions';
import { axiosInstance } from 'App';
import { saveAs } from 'file-saver';

import SelectWithData from '../../Quotes/List/SelectWithData';
import { Backdrop, CircularProgress } from '@material-ui/core';

import fanSizePlusMinus from 'helpers/fanSizePlusMinus';

import { useAuth } from 'providers/auth';
import { useHistory, useLocation } from 'react-router-dom';

const link = '/jobs';

const browseConfig = {
    dataId: 'jobs',
    apiBasePath: link,
    createApiPath: (path, pageNum, pageSize, filterValues) => {
        const urlParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlParams.entries());
       
         if (Object.keys(params).length) {
            var esc = encodeURIComponent;

            const filters = Object.keys(params)
                .map((k) => {
                    return params[k] && esc(k) + '=' + esc(params[k]) + '&';
                })
                .join('');

            return `${path}?pageNum=${pageNum}&pageSize=${pageSize}&sortBy=JobID&${filters}`;
        }
        return `${path}?pageNum=${pageNum}&pageSize=${pageSize}&sortBy=JobID&JobStateIDs=1`;
    },
    tableStructure: [
        {
            title: '',
            align: 'left',
            actions: [
                { title: 'Open/Edit', idField: 'id', action: 'edit', path: link },
                { title: 'Duplicate', idField: 'id', action: 'clone', path: link }
            ],
            sticky: true
        },
        {
            title: 'Job No',
            fieldName: 'id',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Job Status',
            fieldName: 'jobStatusName',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Latest Status Note',
            fieldName: 'jobStatusNotice',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Company Name',
            fieldName: 'clientDetails.name',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.clientDetails && item.clientDetails.name
        },
        {
            title: 'Order Number',
            fieldName: 'attributes.commercialsOrderNumber',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.commercialsOrderNumber
        },
        {
            title: 'Product Area',
            fieldName: 'productAreaName',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Qty',
            fieldName: 'attributes.fanQty',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanQty
        },
        {
            title: 'Design',
            fieldName: 'attributes.fanDesign',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanDesign
        },
        {
            title: 'Size',
            fieldName: 'attributes.fanSize',
            showFilter: false,
            showSort: false,
            formatData: (item) => (item.attributes?.fanSize ? item.attributes?.fanSize : '') + fanSizePlusMinus(item.attributes?.fanSizePlusMinus)
        },
        {
            title: '% Width',
            fieldName: 'attributes.fanPercentageWidth',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanPercentageWidth
        },
        {
            title: 'Arr',
            fieldName: 'attributes.fanArrangement',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanArrangement
        },
        {
            title: 'Hand',
            fieldName: 'attributes.fanHanding',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanHanding
        },
        {
            title: 'Ort',
            fieldName: 'attributes.fanOrt',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanOrt
        },
        {
            title: 'Pos',
            fieldName: 'attributes.fanPos',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanPos
        },
        {
            title: 'Job Date',
            fieldName: 'createdAt',
            showFilter: false,
            showSort: false,
            formatData: (item, fieldName) => {
                const d = item[fieldName];
                return new Date(d).toLocaleDateString('en-AU')
            }
        },
        {
            title: 'Prev Fan Serial',
            fieldName: 'fanSerial',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Quote No',
            fieldName: 'quoteID',
            showFilter: false,
            showSort: false,
            formatData: (item) => `${item['quoteID']}${item['revision']}${item['itemID']}`
        },
        {
            title: 'Commercials Extra',
            fieldName: 'attributes.commercialsExtra',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.commercialsExtra
        },
        {
            title: 'Enquiry Source',
            fieldName: 'enquirySourceName',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.enquirySourceName
        },
        {
            title: 'Sales Rep',
            fieldName: 'salesRepName',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Volume L/s',
            fieldName: 'attributes.fanVolumeLPerS',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanVolumeLPerS
        },
        {
            title: 'Inlet Press Pa',
            fieldName: 'attributes.fanInletPressurePa',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanInletPressurePa
        },
        {
            title: 'Discharge Press Pa',
            fieldName: 'attributes.fanDischargePressurePa',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes && item.attributes.fanDischargePressurePa
        },

        {
            title: 'Aura Job File No',
            fieldName: 'auraJobFileNo',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes?.auraJobFileNo,
        },
        {
            title: 'NYB Sales Memo No',
            fieldName: 'nybSalesMemoNo',
            showFilter: false,
            showSort: false,
            formatData: (item) => item.attributes?.nybSalesMemoNo,
        },

        {
            title: 'Industry',
            fieldName: 'industryName',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Application',
            fieldName: 'applicationName',
            showFilter: false,
            showSort: false,
        },
        {
            title: 'Combined Price',
            fieldName: 'combinedPrice',
            showFilter: false,
            showSort: false,
            formatData: (item, fieldName) => <NumberFormat value={item[fieldName]} displayType={'text'} thousandSeparator isNumericString prefix={'$'} decimalScale={2} fixedDecimalScale />
        },
    ],
    urlPath: link,
    idField: 'quoteID'
};

const createFilterValues = (values, history, searchParams) => {
    const { QuoteNo, ...rest } = values;
    
    const QuoteNoSplit = values.QuoteNo.match(/[a-z]+|\d+/ig) || [];
    const filters = {
        ...rest,
        ...(rest['Created%2eMin'] !== '' && { 'Created%2eMin': new Date(rest['Created%2eMin'] + "T00:00:00.000+10:00").toISOString() }),
        ...(rest['Created%2eMax'] !== '' && { 'Created%2eMax': new Date(rest['Created%2eMax'] + "T24:00:00.000+10:00").toISOString() }),
        ...(rest['Attributes%2eCommercialsOrderDate%2eMin'] !== '' && { 'Attributes%2eCommercialsOrderDate%2eMin': new Date(rest['Attributes%2eCommercialsOrderDate%2eMin'] + "T00:00:00.000+10:00").toISOString() }),
        ...(rest['Attributes%2eCommercialsOrderDate%2eMax'] !== '' && { 'Attributes%2eCommercialsOrderDate%2eMax': new Date(rest['Attributes%2eCommercialsOrderDate%2eMax'] + "T24:00:00.000+10:00").toISOString() }),
        ...(QuoteNoSplit.length >= 1 && { QuoteID: QuoteNoSplit[0] }),
        ...(QuoteNoSplit.length >= 2 && { Revision: QuoteNoSplit[1] }),
        ...(QuoteNoSplit.length >= 3 && { ItemID: QuoteNoSplit[2] }),
    }
    
    searchParams = new URLSearchParams('');

    Object.keys(filters)
        .map((k) => {
            if (filters[k]){
                searchParams.set(k, filters[k]);
            }
        })

    history.replace({ search: searchParams.toString() });

    return filters;
};

const productionAllocatedList = [
    {
        label: 'AirEng',
        id: 'AirEng',
    },
    {
        label: 'Aerotech',
        id: 'Aerotech',
    },
    {
        label: 'Metfab',
        id: 'Metfab',
    },
    {
        label: 'Control Fab',
        id: 'Control Fab',
    },
    {
        label: 'Shearform',
        id: 'Shearform',
    },
    {
        label: '24/7',
        id: '24/7',
    },
    {
        label: 'Other External Fab',
        id: 'Other External Fab',
    },
];

const quoteStateList = [
    {
        "label": "Open",
        "id": 1
    },
    {
        "label": "Archived",
        "id": 2
    }
];

const Jobs = ({ isLoading, salesRepList, jobStatusList, productAreaList, enquirySourceList, jobStateList, industryList, applicationList }) => {
    const { userAttr } = useAuth();
    const dispatch = useDispatch()
    
    const history = useHistory();
    const { search } = useLocation();
    const searchParams = useMemo(() => new URLSearchParams(search), [search]);

    const { setFilterValues, clearFilter } = useContext(BrowseContext);

    const [jsReset, setJsReset] = useState(`js${Date.now()}`);
    const [sReset, setSReset] = useState(`s${Date.now()}`);
    const [paReset, setPaReset] = useState(`pa${Date.now()}`);
    const [esReset, setEsReset] = useState(`es${Date.now()}`);
    const [jStateReset, setJStateReset] = useState(`JState${Date.now()}`);
    const [iReset, setIReset] = useState(`i${Date.now()}`);
    const [aReset, setAReset] = useState(`a${Date.now()}`);

    const params = Object.fromEntries(searchParams.entries());
    const decodedObj = {};

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const decodedValue = typeof params[key] === 'string' ? decodeURIComponent(params[key]) : params[key];
            decodedObj[key] = decodedValue;
        }
    }

    const { QuoteID, Revision, ItemID, ...rest } = decodedObj
    
    return (
        <>
            <Backdrop open={isLoading}>
                <CircularProgress color="primary" />
            </Backdrop>

            <ContentHeader title={'Jobs'} />
            {!isLoading &&
                <Formik
                    initialValues={{
                        JobID: '',
                        ClientName: '',
                        OrderNo: '',
                        QuoteNo: [QuoteID, Revision, ItemID].filter(Boolean).join('') || '',
                        JobStatusIDs: '',
                        SalesRepID: '',
                        FanSerial: '',
                        ProductAreaID: '',
                        EnquirySourceID: '',
                        JobStateIDs: 1,
                        'Created%2eMin': '',
                        'Created%2eMax': '',
                        'Attributes%2eCommercialsOrderDate%2eMin': '',
                        'Attributes%2eCommercialsOrderDate%2eMax': '',
                        'Attributes%2eFanDesign': '',
                        'Attributes%2eFanSize': '',
                        'Attributes%2eCommercialsExtra': '',
                        'Attributes%2eCommercialsOrderNumber': '',
                        'Attributes%2eFanInletPressurePa%2eMin': '',
                        'Attributes%2eFanInletPressurePa%2eMax': '',
                        'Attributes%2eFanDischargePressurePa%2eMin': '',
                        'Attributes%2eFanDischargePressurePa%2eMax': '',
                        'Attributes%2eFanVolumeLPerS%2eMin': '',
                        'Attributes%2eFanVolumeLPerS%2eMax': '',
                        'Attributes%2eFanHanding': '',
                        'Attributes%2eFanOrt': '',
                        'Attributes%2eFanPercentageWidth': '',
                        'Attributes%2eFanArrangement': '',
                        'Attributes%2eProductionAllocated': '',
                        'Attributes%2eAuraJobFileNo': '',
                        'Attributes%2eNYBSalesMemoNo': '',
                        ...rest,
                        ...(rest['Created%2eMin'] && { 'Created%2eMin': new Date(rest['Created%2eMin']).toISOString().split('T')[0]}),
                        ...(rest['Created%2eMax'] && { 'Created%2eMax': new Date(rest['Created%2eMax']).toISOString().split('T')[0]}),
                        ...(rest['Attributes%2eCommercialsOrderDate%2eMin'] && { 'Attributes%2eCommercialsOrderDate%2eMin': new Date(rest['Attributes%2eCommercialsOrderDate%2eMin']).toISOString().split('T')[0]}),
                        ...(rest['Attributes%2eCommercialsOrderDate%2eMax'] && { 'Attributes%2eCommercialsOrderDate%2eMax': new Date(rest['Attributes%2eCommercialsOrderDate%2eMax']).toISOString().split('T')[0]}),
                    }}
                    onSubmit={async (values) => {
                        setFilterValues(createFilterValues(values, history, searchParams));
                    }}
                >
                    {(formProps) => {
                        const { handleSubmit, isSubmitting, setFieldValue, values } = formProps;

                        return (
                            <>
                                <ContentWrapper>
                                    <form onSubmit={handleSubmit}>

                                        <Input
                                            label='Job ID'
                                            name='JobID'
                                            type='number'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Job Created Date Start'
                                            name='Created%2eMin'
                                            type='date'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Job Created Date End'
                                            name='Created%2eMax'
                                            type='date'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Commercials Order Date Start'
                                            name='Attributes%2eCommercialsOrderDate%2eMin'
                                            type='date'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Commercials Order Date End'
                                            name='Attributes%2eCommercialsOrderDate%2eMax'
                                            type='date'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Client Name'
                                            name='ClientName'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Order No'
                                            name='Attributes%2eCommercialsOrderNumber'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Design'
                                            name='Attributes%2eFanDesign'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Size'
                                            name='Attributes%2eFanSize'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Quote No'
                                            name='QuoteNo'
                                            type='text'
                                            style={{ width: '19%', marginRight: '1%' }}
                                        />
                                        <SelectWithData reset={jsReset} setFieldValue={setFieldValue} label='Job Status' name='JobStatusIDs' defaultValue={jobStatusList.find((v) => v.id === decodedObj.JobStatusIDs)} options={jobStatusList} style={{ width: '19%', marginRight: '1%' }} />
                                        <SelectWithData reset={sReset} setFieldValue={setFieldValue} label='Sales Rep' name='SalesRepID' defaultValue={salesRepList.find((v) => v.id === decodedObj.SalesRepID)} options={salesRepList} style={{ width: '19%', marginRight: '1%' }} />
                                        <Input
                                            label='Fan Prev Serial'
                                            name='FanSerial'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Commercials Extra'
                                            name='Attributes%2eCommercialsExtra'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Inlet Pressure Min (Pa)'
                                            name='Attributes%2eFanInletPressurePa%2eMin'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Inlet Pressure Max (Pa)'
                                            name='Attributes%2eFanInletPressurePa%2eMax'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Discharge Pressure Min (Pa)'
                                            name='Attributes%2eFanDischargePressurePa%2eMin'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Discharge Pressure Max (Pa)'
                                            name='Attributes%2eFanDischargePressurePa%2eMax'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Volume Min (L/sec)'
                                            name='Attributes%2eFanVolumeLPerS%2eMin'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Volume Max (L/sec)'
                                            name='Attributes%2eFanVolumeLPerS%2eMax'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Handing'
                                            name='Attributes%2eFanHanding'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Ort'
                                            name='Attributes%2eFanOrt'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Percentage Width'
                                            name='Attributes%2eFanPercentageWidth'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label='Fan Arrangement'
                                            name='Attributes%2eFanArrangement'
                                            type='text'
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <SelectWithData reset={paReset} setFieldValue={setFieldValue} label='Product Area' name='ProductAreaID' defaultValue={productAreaList.find((v) => v.id === parseInt(decodedObj.ProductAreaID))} options={productAreaList} style={{ width: '14%', marginRight: '1%' }} />
                                        <SelectWithData reset={esReset} setFieldValue={setFieldValue} label='Enquiry Source' name='EnquirySourceID' defaultValue={enquirySourceList.find((v) => v.id === parseInt(decodedObj.EnquirySourceID))} options={enquirySourceList} style={{ width: '14%', marginRight: '1%' }} />
                                        { userAttr.roles.includes("Admin") && 
                                            <SelectWithData reset={jStateReset} setFieldValue={setFieldValue} defaultValue={quoteStateList.find((v) => v.id === parseInt(decodedObj.QuoteStateID)) || {label: 'Open', id : 1}} label='Job State' name='JobStateIDs' options={jobStateList} style={{ width: '14%', marginRight: '1%' }} />
                                        }
                                        <SelectWithData
                                            setFieldValue={setFieldValue} 
                                            name="Attributes%2eProductionAllocated"
                                            type="text"
                                            label="Production Allocated"
                                            defaultValue={productionAllocatedList.find((v) => v.id === parseInt(decodedObj.ProductionAllocated))} 
                                            options={productionAllocatedList}
                                            style={{ width: '24%', marginRight: '1%' }}
                                        />

                                        <Input
                                            label="Aura Job File No"
                                            name="Attributes%2eAuraJobFileNo"
                                            type="text"
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <Input
                                            label="NYB Sales Memo No"
                                            name="Attributes%2eNYBSalesMemoNo"
                                            type="text"
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />

                                        <SelectWithData
                                            reset={iReset}
                                            setFieldValue={setFieldValue}
                                            label="Industry"
                                            name="industryID"
                                            defaultValue={industryList.find((v) => v.id === parseInt(decodedObj.industryID))}
                                            options={industryList}
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />
                                        <SelectWithData
                                            reset={aReset}
                                            setFieldValue={setFieldValue}
                                            label="Application"
                                            name="applicationID"
                                            defaultValue={applicationList.find((v) => v.id === parseInt(decodedObj.applicationID))}
                                            options={applicationList}
                                            style={{ width: '14%', marginRight: '1%' }}
                                        />

                                        <Grid container justify="flex-end">
                                            <Button
                                                variant='contained'
                                                color="primary"
                                                type='button'
                                                onClick={() => {
                                                    setFieldValue('JobID', '');
                                                    setFieldValue('Created%2eMin', '');
                                                    setFieldValue('Created%2eMax', '');
                                                    setFieldValue('Attributes%2eCommercialsOrderDate%2eMin', '');
                                                    setFieldValue('Attributes%2eCommercialsOrderDate%2eMax', '');
                                                    setFieldValue('ClientName', '');
                                                    setFieldValue('Attributes%2eCommercialsOrderNumber', '');
                                                    setFieldValue('Attributes%2eFanDesign', '');
                                                    setFieldValue('Attributes%2eFanSize', '');
                                                    setFieldValue('QuoteNo', '');
                                                    setFieldValue('JobStatusIDs', '');
                                                    setJsReset(`js${Date.now()}`);
                                                    setFieldValue('SalesRepID', '');
                                                    setSReset(`s${Date.now()}`);
                                                    setFieldValue('FanSerial', '');
                                                    setFieldValue('Attributes%2eCommercialsExtra', '');
                                                    setFieldValue('Attributes%2eFanInletPressurePa%2eMin', '');
                                                    setFieldValue('Attributes%2eFanInletPressurePa%2eMax', '');
                                                    setFieldValue('Attributes%2eFanDischargePressurePa%2eMin', '');
                                                    setFieldValue('Attributes%2eFanDischargePressurePa%2eMax', '');
                                                    setFieldValue('Attributes%2eFanVolumeLPerS%2eMin', '');
                                                    setFieldValue('Attributes%2eFanVolumeLPerS%2eMax', '');
                                                    setFieldValue('Attributes%2eFanHanding', '');
                                                    setFieldValue('Attributes%2eFanOrt', '');
                                                    setFieldValue('Attributes%2eFanPercentageWidth', '');
                                                    setFieldValue('Attributes%2eFanArrangement', '');
                                                    setFieldValue('Attributes%2eProductionAllocated', '');
                                                    setFieldValue('ProductAreaID', '');
                                                    setPaReset(`pa${Date.now()}`);
                                                    setEsReset(`es${Date.now()}`);
                                                    setJStateReset(`JState${Date.now()}`);
                                                    setFieldValue('Attributes%2eAuraJobFileNo', '');
                                                    setFieldValue('Attributes%2eNYBSalesMemoNo', '');
                                                    setIReset(`i${Date.now()}`);
                                                    setAReset(`a${Date.now()}`);
                                                    
                                                    
                                                    setFilterValues(createFilterValues({
                                                        JobID: '',
                                                        ClientName: '',
                                                        OrderNo: '',
                                                        QuoteNo: '',
                                                        JobStatusIDs: '',
                                                        SalesRepID: '',
                                                        FanSerial: '',
                                                        ProductAreaID: '',
                                                        EnquirySourceID: '',
                                                        JobStateIDs: 1,
                                                        'Created%2eMin': '',
                                                        'Created%2eMax': '',
                                                        'Attributes%2eCommercialsOrderDate%2eMin': '',
                                                        'Attributes%2eCommercialsOrderDate%2eMax': '',
                                                        'Attributes%2eFanDesign': '',
                                                        'Attributes%2eFanSize': '',
                                                        'Attributes%2eCommercialsExtra': '',
                                                        'Attributes%2eCommercialsOrderNumber': '',
                                                        'Attributes%2eFanInletPressurePa%2eMin': '',
                                                        'Attributes%2eFanInletPressurePa%2eMax': '',
                                                        'Attributes%2eFanDischargePressurePa%2eMin': '',
                                                        'Attributes%2eFanDischargePressurePa%2eMax': '',
                                                        'Attributes%2eFanVolumeLPerS%2eMin': '',
                                                        'Attributes%2eFanVolumeLPerS%2eMax': '',
                                                        'Attributes%2eFanHanding': '',
                                                        'Attributes%2eFanOrt': '',
                                                        'Attributes%2eFanPercentageWidth': '',
                                                        'Attributes%2eFanArrangement': '',
                                                        'Attributes%2eProductionAllocated': '',
                                                        'Attributes%2eAuraJobFileNo': '',
                                                        'Attributes%2eNYBSalesMemoNo': '',
                                                    }, history, new URLSearchParams()));
                                                }}
                                            >
                                                Reset Filters
                                            </Button>
                                            &nbsp;
                                            <Button
                                                variant='contained'
                                                color="secondary"
                                                type='submit'
                                                disabled={isSubmitting}
                                            >
                                                Filter Jobs
                                            </Button>
                                        </Grid>
                                    </form>
                                </ContentWrapper>

                                <BrowseData minWidth="1500px" />

                                <Grid container justify="flex-end">
                                    <Button
                                        variant='contained'
                                        color='primary'
                                        onClick={async () => {
                                            const url = browseConfig.createApiPath(
                                                browseConfig.apiBasePath, 
                                                1, 
                                                10000000, 
                                                setFilterValues(createFilterValues(values, history, searchParams))
                                            );
                                            const res = await axiosInstance({ url });

                                            if (res.data.length > 0) {
                                                const csvHeaders = [
                                                    'Job No',
                                                    'Job Date',
                                                    'Client Name',
                                                    'Client State',
                                                    'Product Area',
                                                    'Sales Rep',
                                                    'Combined Price Sell',
                                                    'Combined Price Cost',
                                                ]

                                                const csvData = res.data.map(({
                                                    id,
                                                    createdAt,
                                                    clientDetails,
                                                    salesRepName,
                                                    productAreaName,
                                                    combinedPrice,
                                                    combinedCost }) => {

                                                    const {name, state} = clientDetails != null ? { name: clientDetails.name, state: clientDetails.addressDetails.state } : { name: 'NA', state: 'NA' };
                                                    
                                                    return `${id},\
                                                    ${new Date(createdAt).toLocaleDateString('en-AU')},${name},${state},${productAreaName},${salesRepName != null ? salesRepName : ''},${combinedPrice},${combinedCost}`
                                                }).join('\n');

                                                const blob = new Blob([
                                                    `${csvHeaders.join(",")} \n` +
                                                    csvData
                                                ], { type: "text/plain;charset=utf-8" });
                                                saveAs(blob, `report.csv`);
                                            } else {
                                                dispatch(addFeedback('No results found matching filter to export', 'error'));
                                            }
                                        }}
                                    >
                                        Export to .csv
                                    </Button>
                                </Grid>
                            </>
                        );
                    }}
                </Formik>

            }
        </>
    );
};

const WrappedApp = (props) => (
    <BrowseProvider config={browseConfig} pageSize={15}>
        <Jobs {...props} />
    </BrowseProvider>
);

export default WrappedApp;
